import { gql } from '__generated__';

export default gql(`
  mutation ActivateCoupon($id: ID!) {
    activateCoupon(id: $id) {
      id
      active
    }
  }
`);
